























import { Component, Prop, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { appStore } from '@/store'

@Component
export default class AtomButton extends ComponentVue {
  @Ref()
  atomButton!: any

  @Prop({ type: Boolean, default: false })
  small!: boolean

  @Prop({ type: Boolean, default: false })
  loading!: boolean

  @Prop({ type: Boolean, default: false })
  primary!: boolean

  @Prop({ type: Boolean, default: false })
  block!: boolean

  @Prop({ type: Boolean, default: false })
  autofocus!: boolean

  @Prop({ type: Boolean, default: false })
  disabled!: boolean

  @Prop({ type: Number, default: 500 })
  emitIntervalMs!: number

  isEmit: boolean = true

  get color(): string {
    if (this.primary) return 'primary'
    return 'white'
  }

  get styles(): object {
    if (this.fontSizeType === 'normal') {
      return {}
    }

    return {
      'font-size': this.fontSize + 'px'
    }
  }

  get fontSize(): number {
    return appStore._fontSizeNormal
  }

  get fontSizeType(): string {
    return appStore._fontSizeType
  }

  onClick(event: any): void {
    if (this.isEmit) {
      this.$emit('click', event)
      this.isEmit = false

      setTimeout(() => (this.isEmit = true), this.emitIntervalMs)
    }
  }
}
